import { ADD_NAVIGATION_ITEM, REMOVE_NAVIGATION_ITEM } from 'design-comuni-plone-theme/actions';

const initialState = {
    error: null,
    items: [],
    loaded: false,
    loading: false,
};

export function customNavigation(state = initialState, action = {}) {
    switch (action.type) {
        case ADD_NAVIGATION_ITEM:
            return {
                ...state,
                items: [...state.items, action.payload],
            };
        case REMOVE_NAVIGATION_ITEM:
            return {
                ...state,
                items: state.items.filter(item => item.id !== action.key),
            };
        default:
            return state;
    }
}